var Analytics = function() {
    //Global site tag (gtag.js) - Google Analytics
    let dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-155746065-1');
}

export { Analytics };